'use client';
import { useHeader } from '@/components/complex/header';
import { useBottomNavigation } from '@/components/complex/bottom-navigation';
import styles from './styles.module.scss';
import FeedItems from '@/components/complex/feed-items';
import Typography from '@/components/primitives/typography';
import type { FeedDto } from '@/api/feed';
import Link from 'next/link';
import Image from 'next/image';

interface HomeScreenProps {
  initialFeeds: FeedDto[];
}

const HomeScreen = ({ initialFeeds }: HomeScreenProps) => {

  useHeader({
    useBack: false,
    desktopTitle: '피드',
  });

  useBottomNavigation(true);

  return (
    <div className={styles.container}>
      <h1 className={styles.visuallyHidden}>로네 — 주변의 숨은 맛집과 명소를 발견하세요</h1>
      <FeedItems
        feeds={initialFeeds}
        sortType="LATEST"
        onEmptyResult={() => (
          <div className={styles.centeredContainer}>
            <Typography className={styles.emptyText} align="center" size="small">
              표시할 피드가 없어요
            </Typography>
          </div>
        )}
      />
      <noscript>
        <nav aria-label="최신 피드 바로가기">
          <ul className={styles.fallbackFeedLinks}>
            {initialFeeds.map((feed) => {
              if (!feed.sid) return null;

              const author = feed.owner?.nickname || feed.owner?.name || '로네 사용자';
              const caption = feed.caption?.slice(0, 80);
              const imageUrl = feed.files[0]?.file.url;

              return (
                <li key={feed.sid}>
                  <Link className={styles.fallbackFeedLink} href={`/feeds/${feed.sid}`}>
                    {imageUrl && (
                      <Image
                        src={`${imageUrl}/w512`}
                        width={480}
                        height={480}
                        alt={caption || `${author}의 피드 이미지`}
                      />
                    )}
                    <strong>{author}</strong>
                    {caption && <span>{caption}</span>}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </noscript>
    </div>
  );
};

export default HomeScreen;
